export const FUSE_DEFAULT_OPTIONS = {
  ignoreLocation: true,
  includeScore: true,
  includeMatches: true,
  threshold: 0.4,
};
